module.exports = __webpack_public_path__ + "img/DE00123.dd211b2a.png";